import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {CustomerManager} from '../../data/manager/customer/customer/customer.manager';

@Injectable({
  providedIn: 'root',
})
export class PhoneValidationFormVm {
  constructor(private customerManager: CustomerManager) { }

  validateSmsToken(phone, call?, whatsapp?, register?): Observable<any> {
    return this.customerManager.validateSmsToken(phone, call, whatsapp, register);
  }

  validateCodeToken(phone, code): Observable<any> {
    return this.customerManager.validateCodeToken(phone, code);
  }

  validateSmsTokenFinal(): Observable<any> {
    return this.customerManager.validateSmsTokenFinal()
      .pipe(map(response => (response.tokenFarmatodo ? response.tokenFarmatodo : null)));
  }

  validateWhatsapp(data): Observable<any> {
    return this.customerManager.validateWhatsapp(data);
  }

  getUser() {
    return this.customerManager.customer;
  }

  sendMessage(data, id): Observable<any> {
    let methodMessage = {};
    methodMessage = data && data.type === 'email'
      ? {byEmail: true, idCustomer: id} : data && data.type === 'phone'
        ? {byPhone: true, idCustomer: id} : {byWhatsapp: true, idCustomer: id};
    return this.customerManager.sendMessage(methodMessage);
  }

  getConfigurationModules(moduleName): any {
    const dataHome= this.customerManager.getConfigurationModule('home');
    return dataHome ? dataHome[moduleName] : {};
  }
}
